module.exports = __webpack_public_path__ + "static/media/desktop.92ee9366.svg";